import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  Tooltip,
  TableSortLabel,
  Grid,
  TableBody,
  TablePagination,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import theme from "../../theme";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {},
  tableWrapper: {
    overflowX: "auto",
  },
  tableRow: {
    textAlign: "start",
    padding: "5px 5px 5px 5px",
  },
  tablePagination: {
    display: "flex",
    justifyContent: "end",
    "& .MuiTablePagination-selectLabel": {
      marginBottom: 0,
    },
    "& .MuiTablePagination-displayedRows": {
      marginBottom: 0,
    },
  },
  tableThText: {
    fontWeight: "bold",
    fontSize: "14px",
    fontFamily: "Poppins !important",
    textAlign: "start",
  },
  tableTrText: {
    fontSize: "14px",
    textAlign: "start",
    fontFamily: "Poppins !important",
    padding: "5px",
  },
  headerTitle: {
    fontSize: "16px",
    fontWeight: "500",
    color: `${theme.palette.primary.darkGray}`,
    fontFamily: "Poppins !important"
  },
  stickyColumn: {
    position: "sticky",
    left: 0,
  },
});

export const TableComponent = ({
  title,
  columns,
  rows,
  page,
  rowsPerPage,
  orderBy,
  order,
  handleEditClick,
  handleViewClick,
  handleDeleteClick,
  handleUploadClick,
  loading,
  handleChangeRowsPerPage,
  handleChangePage,
  total,
  handleSorting,
  isdisplay
}) => 
  
  {
    
  const classes = useStyles();
  const [dataField, setDataField] = useState([]);



  useEffect(() => {
    setDataField([]);
    columns?.map((itm) => {
      setDataField((prevArray) => [...prevArray, itm?.id]);
    });
  }, [columns]);

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Card>
          <CardHeader
            style={{
              borderBottom: `1px solid ${theme.palette.primary.lightGray}`,
              borderLeft: `3px solid ${theme.palette.primary.darkYellow}`,
            }}
            classes={{ title: classes.headerTitle }}
            title={title}
          />

          {loading ? (
            <Box className={"text-center m-4"}>
              <CircularProgress color="primary" />
            </Box>
          ) : (
            <>
              {isdisplay ? (
                <CardContent className={"overflow-scroll"}>
                  <Table className={classes.table} aria-labelledby="tableTitle">
                    <TableHead>
                      <TableRow>
                        {columns?.map((item, index) => (

                          <TableCell
                            className={classes.tableRow}
                            key={index}
                            align={"left"}
                          >
                            <Tooltip
                              title={item?.label}
                              placement={
                                item?.numeric ? "bottom-end" : "bottom-start"
                              }
                              enterDelay={300}
                            >
                              {item?.activeSort ? (
                                <>
                                  {item?.id === orderBy ? (
                                    <TableSortLabel
                                      active={item?.activeSort}
                                      direction={
                                        item?.id === orderBy
                                          ? order === 1
                                            ? "asc"
                                            : "desc"
                                          : ""
                                      }
                                      onClick={() => handleSorting(item?.id)}
                                    >
                                      <Typography
                                        className={classes.tableThText}
                                      >
                                        {item?.label}
                                      </Typography>
                                    </TableSortLabel>
                                  ) : (
                                    <TableSortLabel
                                      // active={item?.activeSort}
                                      onClick={() => handleSorting(item?.id)}
                                    >
                                      <Typography
                                        className={classes.tableThText}
                                      >
                                        {item?.label}
                                      </Typography>
                                    </TableSortLabel>
                                  )}
                                </>
                              ) : (
                                <Typography className={classes.tableThText}>
                                  {item?.label}
                                </Typography>
                              )}
                            </Tooltip>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      
                      {rows?.map((item, index) => {
                        return (
                          <TableRow
                            hover
                            className={classes.tableTrText}
                            tabIndex={-1}
                            key={index}
                          >
                            {dataField?.map((key, ind) => (
                              <TableCell
                                key={ind}
                                className={
                                  key === "action"
                                    ? `stickyColumn ${classes.tableTrText}`
                                    : classes.tableTrText
                                }
                                component="th"
                                scope="row"
                              >
                                {key === "action" ? (
                                  <Grid
                                    container
                                    className={"cursor-pointer d-flex"}
                                    style={{ flexWrap: "nowrap" }}
                                  >
                                    <span
                                      style={{ padding: 5 }}
                                      onClick={() => {
                                        handleEditClick(item);
                                      }}
                                    >
                                      {item[key]?.actionEdit}
                                    </span>
                                    <span
                                      style={{ padding: 5 }}
                                      onClick={() => {
                                        handleViewClick(item);
                                      }}
                                    >
                                      {item[key]?.actionView}
                                    </span>
                                    <span
                                      style={{ padding: 5 }}
                                      onClick={() => {
                                        handleDeleteClick(item);
                                      }}
                                    >
                                      {item[key]?.actionDelete}
                                    </span>

                                  
                                    <span
                                      style={{ padding: 5 }}                                   
                                    >
                                      <input
                                        id={`file[${index}]`}
                                        type={"file"}
                                        accept={".csv"}
                                        style={{ display: "none" }}
                                        onChange={(e) => handleUploadClick(e, item)}                                      
                                      />
                                      <label htmlFor={`file[${index}]`}>
                                        {item[key]?.actionUpload}
                                      </label>
                                    </span>
                                  </Grid>
                                ) : (
                                  <>{item[key]}</>
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </CardContent>
              ) 
              : (
                <div className="text-center m-4">
                  <ErrorOutlineIcon />
                  <Typography className="f-color-gray">
                    No data found
                  </Typography>
                </div>
              )
              }
            </>
          )}
        </Card>
      </div>
      {!(rows?.length === total) && (
        <TablePagination
          className={classes.tablePagination}
          count={total}
          rowsPerPageOptions={[10, 20, 50, 100]}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
        />
      )}
    </Paper>
  );
};

TableComponent.prototype = {
  title: PropTypes.string,
  columns: PropTypes.array,
  rows: PropTypes.array,
  rowsPerPage: PropTypes.number,
  setRowsPerPage: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func,
  order: PropTypes.string,
  setOrder: PropTypes.func,
  orderBy: PropTypes.string,
  setOrderBy: PropTypes.func,
  handleEditClick: PropTypes.func,
  handleViewClick: PropTypes.func,
  handleDeleteClick: PropTypes.func,
  handleUploadClick: PropTypes.func,
  loading: PropTypes.bool,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  total: PropTypes.any,
  handleSorting: PropTypes.func,
  isdisplay: PropTypes.bool,
};
